export const proposalStats = state => state.proposalStats
export const proposalStatsById = state => id => _.find(proposalStats(state), {id})
export const proposalStatsByIds = state => ids => {
    return _.reduce(ids, (res, id) => {
        let proposalStats = proposalStatsById(state)(id)
        if (proposalStats) res.push(proposalStats)
        return res
    }, [])
}
